import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="text-center text-sm text-gray-400">
          <p>All Prices in Jita are based on Jita 4-4.</p>
          <p className="mt-2">
          EVE Online and all related logos and content are trademarks of CCP ehf.
          </p>
          <p className="mt-2">.....</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;